<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <div>
                            <!--<el-button type="primary" size="mini" @click="transfer" :disabled="!btn.transfer">{{$t('getapi[6917]')}}</el-button>-->
                            <el-button type="primary" size="mini" @click.native="expStandBook">{{$t('getapi[6918]')}}</el-button>
                        </div>
                        <el-table
                                id="xpane-0"
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_No" :label="$t('getapi[6919]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6920]')"></el-table-column>
                            <el-table-column prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person_Dept" :label="$t('getapi[6041]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Name" :label="$t('getapi[6921]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Des" :label="$t('getapi[6922]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Type" :label="$t('getapi[6923]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Carrier" :label="$t('getapi[6924]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Start_Place" :label="$t('getapi[6925]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="End_Place" :label="$t('getapi[6926]')"></el-table-column>
                            <el-table-column prop="Start_Time" :label="$t('getapi[6927]')">
                                <template slot-scope="scope">
                                    {{scope.row.Start_Time | toDate}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="End_Time" :label="$t('getapi[6928]')">
                                <template slot-scope="scope">
                                    {{scope.row.End_Time | toDate}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Car_Type" :label="$t('getapi[6929]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
                            <el-table-column prop="Expect_Cost" :label="$t('getapi[6930]')" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.Expect_Cost | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Driver_Phone" :label="$t('getapi[6931]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Car_Num" :label="$t('getapi[5012]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="GetPlace_Time" :label="$t('getapi[6932]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Actual_Cost" :label="$t('getapi[6933]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Cost" :label="$t('getapi[6934]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Remark" :label="$t('getapi[6947]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Receipt_Time" :label="$t('getapi[6501]')"></el-table-column>
                            <el-table-column prop="Receipt_Url" :label="$t('getapi[6935]')">
                                <template scope="scope">
                                    <a v-if="scope.row.Receipt_Url != '' && scope.row.Receipt_Url != null" @click="open(scope.row.Receipt_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Trans_Content" :label="$t('getapi[6936]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="NoTaxed_Cost" :label="$t('getapi[6937]')"></el-table-column>
                            <el-table-column prop="Invoice_Flag" :label="$t('getapi[8537]')">
                                <template scope="scope">
                                    {{scope.row.Invoice_Flag == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6362]')" name="1">
                        <div>
                            <!--<el-button type="primary" size="mini" @click="transfer" :disabled="!btn.transfer">{{$t('getapi[6917]')}}</el-button>-->
                            <el-button type="primary" size="mini" @click.native="expStandBook">{{$t('getapi[6918]')}}</el-button>
                        </div>
                        <el-table
                                id="xpane-1"
                                :data="personData"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_No" :label="$t('getapi[6919]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6920]')"></el-table-column>
                            <el-table-column prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person_Dept" :label="$t('getapi[6041]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Name" :label="$t('getapi[6921]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Des" :label="$t('getapi[6922]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Type" :label="$t('getapi[6923]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Goods_Carrier" :label="$t('getapi[6924]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Start_Place" :label="$t('getapi[6925]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="End_Place" :label="$t('getapi[6926]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Start_Time" :label="$t('getapi[6927]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="End_Time" :label="$t('getapi[6928]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Car_Type" :label="$t('getapi[6929]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Expect_Cost" :label="$t('getapi[6930]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Driver_Phone" :label="$t('getapi[6931]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Car_Num" :label="$t('getapi[5012]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="GetPlace_Time" :label="$t('getapi[6932]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Actual_Cost" :label="$t('getapi[6933]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Cost" :label="$t('getapi[6934]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Remark" :label="$t('getapi[6947]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Receipt_Time" :label="$t('getapi[6501]')"></el-table-column>
                            <el-table-column prop="Receipt_Url" :label="$t('getapi[6935]')">
                                <template scope="scope">
                                    <a v-if="scope.row.Receipt_Url != '' && scope.row.Receipt_Url != null" @click="open(scope.row.Receipt_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Trans_Content" :label="$t('getapi[6936]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="NoTaxed_Cost" :label="$t('getapi[6937]')"></el-table-column>
                            <el-table-column prop="Invoice_Flag" :label="$t('getapi[8537]')">
                                <template scope="scope">
                                    {{scope.row.Invoice_Flag == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex;">
                    <el-button type="primary" size="mini" @click.native="email" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[6938]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(1)" :disabled="!btn.submit">{{$t('getapi[6468]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="unusualSetStatus(1)" :disabled="!btn.unusualsubmit || dataDetail.Master.Unusual_Cost == 0">{{$t('getapi[6939]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="recall" :disabled="dataDetail.Master.Status != 1">{{$t('getapi[6940]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(4)" :disabled="!btn.close">{{$t('getapi[441]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(5)" :disabled="!btn.close || dataDetail.Master.Status == 1">{{$t('getapi[1902]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :http-request="uploadFile"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">{{$t('getapi[6941]')}}
                        </el-button>
                    </el-upload>
                    <el-button type="primary" size="mini" @click.native="copy" :disabled="dataDetail.Master.Exclusively_ID == 0" style="margin-left: 8px">{{$t('getapi[35]')}}</el-button>
                </div>
                <div style="width:630px;min-width:630px">
                    <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{$t('getapi[6919]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Master.Doc_No" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{$t('getapi[552]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input :value="expStatus(dataDetail.Master.Status)" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{$t('getapi[6942]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input :value="expStatus(dataDetail.Master.UCStatus)" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[410]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Create_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[135]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Create_Time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[733]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Modify_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[1210]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Modify_Time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[6041]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Create_Person_Dept" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[4126]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Create_Time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6938]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Notice_Log" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[6269]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Notice_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <el-divider content-position="left">{{$t('getapi[6943]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td >{{$t('getapi[6921]')}}</td>
                            <td >
                                <el-input v-model="dataDetail.Master.Goods_Name" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Goods_Name" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            </td>
                            <!--<td>物品描述</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Goods_Des" type="text" size="mini"></el-input>
                            </td>-->
                            <td>{{$t('getapi[6923]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Goods_Type" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-select filterable v-model="dataDetail.Master.Goods_Type" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" size="mini">
                                    <el-option v-for="item in goodsTypeArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code" style="width:100%"></el-option>
                                </el-select>
                            </td>
                            <td>{{$t('getapi[6925]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Start_Place" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Start_Place" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6926]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.End_Place" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="textarea" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.End_Place" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="textarea" size="mini"></el-input>
                            </td>
                            <td>{{$t('getapi[6927]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Start_Time" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-date-picker v-model="dataDetail.Master.Start_Time" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="datetime" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[6928]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.End_Time" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-date-picker v-model="dataDetail.Master.End_Time" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="datetime" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[876]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Item_ShotrCode" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="5" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                                <el-input
                                        v-model="dataDetail.Master.Item_ShotrCode"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItemCode()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[546]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Item_Name" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[2610]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Customer_Code" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6929]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Car_Type" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-select filterable v-model="dataDetail.Master.Car_Type" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" size="mini">
                                    <el-option v-for="item in CarTypeArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code" style="width:100%"></el-option>
                                </el-select>
                            </td>
                            <td>{{$t('getapi[140]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Volume" type="text" size="mini" :readonly="dataDetail.Master.Car_Type!='配载'" :class="{'readO':dataDetail.Master.Car_Type!='配载'}"></el-input>
                            </td>
                            <td>{{$t('getapi[138]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Weight" type="text" size="mini" :readonly="dataDetail.Master.Car_Type!='配载'" :class="{'readO':dataDetail.Master.Car_Type!='配载'}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6944]')}}</td>
                            <el-input v-model="dataDetail.Master.Quantity" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            <el-input v-model="dataDetail.Master.Quantity" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            <td>{{$t('getapi[6945]')}}</td>
                            <td>
                                <el-checkbox v-model="dataDetail.Master.Back_Track">
                                </el-checkbox>
                            </td>
                            <td>{{$t('getapi[6979]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Goods_Value" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="number" autocomplete="off" title="" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Goods_Value" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <!--<td>运输内容</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Trans_Content" type="text" size="mini"></el-input>
                            </td>-->
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6980]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Goods_Currency" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="24" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                                <el-select filterable v-model="dataDetail.Master.Goods_Currency"  class="mcolor" size="mini">
                                    <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                               :value="item.currency_code" :key="index"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[143]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Remark" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <!--<tr>
                            <td>外协单号</td>
                            <td>
                                <el-input v-model="dataDetail.Master.IPO_Code" type="text" size="mini"></el-input>
                            </td>
                            <td>销售单号</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Sale_Code" type="text" size="mini"></el-input>
                            </td>
                            <td>采购单号</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Pur_Code" type="text" size="mini"></el-input>
                            </td>
                        </tr>-->
                        <tr>
                            <td colspan="6">
                                <el-divider content-position="left">{{$t('getapi[6946]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[1196]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Vender_Code" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="26" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                                <el-input
                                        v-model="dataDetail.Master.Vender_Code"
                                        type="text"
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectVenderCode()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[6924]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Goods_Carrier" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Goods_Carrier" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            </td>
                            <td>{{$t('getapi[6930]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Expect_Cost" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="number" autocomplete="off" title="" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Expect_Cost" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.Master.Status==2 || dataDetail.Master.Status==4" :class="[dataDetail.Master.Status==2 || dataDetail.Master.Status==4?'readO':'mcolor']"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6931]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Driver_Phone" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Driver_Phone" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            </td>
                            <td>{{$t('getapi[5012]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Car_Num" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-model="dataDetail.Master.Car_Num" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                            </td>
                            <!--<td>到提货地点时间</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.GetPlace_Time" type="datetime" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>-->
                            <td>{{$t('getapi[6933]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Actual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="getNoTaxedCost"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6934]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Unusual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.Master.UCStatus != 0 && dataDetail.Master.UCStatus != 3" :class="{'readO':dataDetail.Master.UCStatus != 0 && dataDetail.Master.UCStatus != 3}"></el-input>
                            </td>
                            <td>{{$t('getapi[6948]')}}</td>
                            <td>
                                <routejump :urlNo="24">
                                <el-select filterable v-model="dataDetail.Master.Unusual_Cost_Currency" size="mini">
                                    <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                               :value="item.currency_code" :key="index"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[6947]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Unusual_Remark" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6501]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Receipt_Time" type="text" size="mini"></el-input>
                            </td>
                            <td>{{$t('getapi[6935]')}}</td>
                            <td>
                                <!--<el-input v-model="dataDetail.Master.Receipt_Url" type="text" size="mini" :disabled="true"></el-input>-->
                                <a v-if="dataDetail.Master.Receipt_Url != null  && dataDetail.Master.Receipt_Url != ''" @click="open(dataDetail.Master.Receipt_Url)" style="text-decoration:underline;color:blue">查看回单</a>
                                <el-button v-if="dataDetail.Master.Receipt_Url != null  && dataDetail.Master.Receipt_Url != ''" icon="el-icon-delete" type="text" size="small" @click="dataDetail.Master.Receipt_Url = '';dataDetail.Master.Receipt_Time = ''"></el-button>
                            </td>
                            <td>{{$t('getapi[2992]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Invoice_No" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6937]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.NoTaxed_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <!--<tr>

                            <td>单次公里数</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Single_Mile" type="text" size="mini"></el-input>
                            </td>
                        </tr>-->
                    </table>
                </div>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6949]')}}</el-divider>
                </div>
                <div>
                    <el-button type="primary" @click="addPrint" size="mini">{{$t('getapi[878]')}}</el-button>
                    <el-button type="primary" @click="delPrint" size="mini">{{$t('getapi[3889]')}}</el-button>
                    <el-button type="primary" @click="batchPrintDate" size="mini" :disabled="selectDataPrint.length == 0">{{$t('getapi[6950]')}}</el-button>
                    <el-table
                            id="xdetilpane-0"
                            :data="dataDetail.DTLog_Car_PrintNo" :height="120" size="mini" border
                              style="width: 100%;" header-row-class-name="headerclass"
                              :row-class-name="tableRowClassNamePrint"
                              @selection-change="handleSelectionChangePrint">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="print_no" :label="$t('getapi[6949]')" width="150">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.print_no" type="text" readonly
                                          size="mini">
                                    <i class="el-icon-edit el-input__icon" slot="suffix"
                                       @click="selectprintno(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="Sign_Time" :label="$t('getapi[6504]')" width="200">
                            <!--<template slot-scope="scope">
                                <el-date-picker v-model="scope.row.Sign_Time" size="mini"></el-date-picker>
                            </template>-->
                        </el-table-column>
                    </el-table>
                </div>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6934]')}}</el-divider>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" type="primary" @click="addunline" :disabled="dataDetail.Master.UCStatus == 1">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delunline" :disabled="dataDetail.Master.UCStatus == 1">{{$t('getapi[40]')}}</el-button>
                    <el-button size="mini" type="primary" @click="saveun">{{$t('getapi[937]')}}</el-button>
                </div>
                <el-table
                        id="xdetilpane-4"
                        :data="dataDetail.Log_Car_UnusualCostList" :height="120" size="mini" border
                        style="width: 100%;"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassNameun"
                        @selection-change="handleSelectionChangeun"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="Unusual_Remark" :label="$t('getapi[143]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Unusual_Remark" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Status" :label="$t('getapi[552]')">
                        <template scope="scope">
                            <el-input :value="expunStatus(scope.row.Status)" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[410]')">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')">
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost" :label="$t('getapi[6934]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Unusual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Currency" :label="$t('getapi[6379]')">
                        <template scope="scope">
                            <el-select filterable v-model="scope.row.Unusual_Cost_Currency" size="mini">
                                <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                           :value="item.currency_code" :key="index"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Vender_Code" :label="$t('getapi[1323]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Vender_Code"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Url" :label="$t('getapi[7021]')">
                        <template scope="scope">
                            <a v-if="scope.row.Unusual_Cost_Url != '' && scope.row.Unusual_Cost_Url != null" @click="open(scope.row.Unusual_Cost_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Time" :label="$t('getapi[7022]')">
                    </el-table-column>
                    <el-table-column align="center" :label="$t('getapi[6974]')" width="120">
                        <template slot-scope="scope" v-if="!$limits.fnIsEmpty(scope.row.Exclusively_ID)">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    action=""
                                    :on-preview="handlePreview5"
                                    :on-remove="handleRemove5"
                                    :on-change="handleChange5"
                                    :on-success="handleSuccess5"
                                    :on-error="handleError5"
                                    :http-request="uploadFile5"
                                    :auto-upload="true"
                                    style="margin-left: 8px;"
                            >
                                <el-button type="primary" size="mini" @click="bindId(scope.row.Exclusively_ID)">{{$t('getapi[6974]')}}
                                </el-button>
                            </el-upload>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[941]')}}</el-divider>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" type="primary" @click="addauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[40]')}}</el-button>
                    <el-button size="mini" type="primary" @click="saveauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[937]')}}</el-button>
                </div>
                <el-table
                        id="xdetilpane-1"
                        :data="dataDetail.DTAuditInfo" :height="120" size="mini" border
                          style="width: 100%;" header-row-class-name="headerclass"
                          :row-class-name="tableRowClassName1"
                        @selection-change="handleSelectionChangeAuditer">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sort" :label="$t('getapi[13120]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Sort" type="text" size="mini" v-if="(dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3) && dataDetail.Master.IsEdit != 1"></el-input>
                            <span v-if="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3)|| dataDetail.Master.IsEdit == 1">{{scope.row.Sort}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Audit_Person"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                                    v-if="(dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3) && dataDetail.Master.IsEdit != 1"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectAuditer(scope)"></i>
                            </el-input>
                            <span v-if="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3)|| dataDetail.Master.IsEdit == 1">{{scope.row.Audit_Person}}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>-->
                    <el-table-column prop="Audit_Status" :label="$t('getapi[6470]')">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6471]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                        <template slot-scope="scope">
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,1)" type="text" size="mini">{{$t('getapi[941]')}}</el-button>
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,2)" type="text" size="mini">{{$t('getapi[6228]')}}</el-button>
                            <el-button v-if="addoredit != 1 && dataDetail.Master.Status==0 && dataDetail.Master.Unusual_Cost < 1000  && !btn.onlyone" @click.native.prevent="delAuditer(scope)" type="text" size="mini">{{$t('getapi[3889]')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6951]')}}</el-divider>
                </div>
                <el-table
                        id="xdetilpane-2"
                        :data="dataDetail.DTAuditInfo" :height="120" size="mini" border
                          style="width: 100%;" header-row-class-name="headerclass"
                          :row-class-name="tableRowClassName2">
                    <!--<el-table-column show-overflow-tooltip prop="Sort" label="审核人顺序"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>-->
                    <el-table-column prop="Audit_Status" :label="$t('getapi[6470]')">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6471]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-button style="padding:0px"  v-if="(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1)" @click.native.prevent="Audit(scope,1)" type="text" size="small">{{$t('getapi[941]')}}</el-button>
                            <el-button style="padding:0px"  v-if="(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1)" @click.native.prevent="Audit(scope,2)" type="text" size="small">{{$t('getapi[6228]')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row v-if="SelectIndexs == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="LogCarViewInfo" ref="ser" @getser="serclick"></serce>
        <el-dialog v-dialogDrag
                   :title="$t('getapi[6472]')"
                   :visible.sync="CloseDialogVisible"
                   width="30%"
        >
            <el-input
                    type="textarea"
                    :rows="5"
                    v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmAudit(selectrow,2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog v-dialogDrag
                   :title="$t('getapi[6504]')"
                   :visible.sync="showPrintDate"
                   width="15%"
        >
            <el-date-picker v-model="printdate" type="date" size="mini"
                            style="width:100%"></el-date-picker>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmBatchPrintDate()" size="mini">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getItemCode" ref="itemcode"></selector>
        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Invoice/GetPurInvoiceSupplyList'" @callback="getVenderCode" ref="vendercode"></selector>
        <!--选择打印嘛-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/Basic/Popup/GetSALShipNoteMasterPopuDataList'" @callback="getSaleShipNote" ref="saleshipnote"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSALShipNoteMasterPopuDataList'" @callback="getSaleShipNote" ref="saleshipnotesingle"></selector>
        <!--审核人-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getAuditer" ref="auditer"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'logcarview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                personData: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('logcarview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight1_1,
                code: '',
                dataDetail: {
                    Master: {},
                    DTAuditInfo: [],
                    DTLog_Car_PrintNo: [],
                    Log_Car_UnusualCostList:[],
                },
                goodsTypeArray: [
                    {
                        Code: '搬家',
                        Name: this.$t('getapi[8650]')//'搬家'
                    },
                    {
                        Code: '出口费用',
                        Name: this.$t('getapi[8651]')//'出口费用'
                    },
                    {
                        Code: '进口费用',
                        Name: this.$t('getapi[12509]')//'进口费用'
                    },
                    {
                        Code: '短驳',
                        Name: this.$t('getapi[8652]')//'短驳'
                    },
                    {
                        Code: '国内成品',
                        Name: this.$t('getapi[8653]')//'国内成品'
                    },
                    {
                        Code: '包月',
                        Name: this.$t('getapi[8654]')//'包月'
                    },
                    {
                        Code: '其他',
                        Name: this.$t('getapi[224]')//'其他'
                    },
                ],
                CarTypeArray:[
                    {
                        Code: '4米2',
                        Name: this.$t('getapi[8655]')//'4米2'
                    },
                    {
                        Code: '6米8',
                        Name: this.$t('getapi[8656]')//'6米8'
                    },
                    {
                        Code: '9米6',
                        Name: this.$t('getapi[8657]')//'9米6'
                    },
                    {
                        Code: '13米',
                        Name: this.$t('getapi[8658]')//'13米'
                    },
                    {
                        Code: '17米',
                        Name: this.$t('getapi[8659]')//'17米'
                    },
                    {
                        Code: '三轮车',
                        Name: this.$t('getapi[8660]')//'三轮车'
                    },
                    {
                        Code: '配载',
                        Name: this.$t('getapi[8661]')//'配载'
                    },
                ],
                CloseDialogVisible: false,
                selectrow: {},
                resontxt: '',
                uploadurl: '',
                fileList: [],
                file: null,
                fileList5: [],
                file5: null,
                Line_ID: '',
                btn: {
                    submit: false,
                    close: true,
                    transfer: false,
                    onlyone: false,//审核人是否唯一
                    unusualsubmit: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                selectData: [],
                selectunData: [],
                currentAuditId: 0,
                addoredit: 1,
                timeId: null,
                selectDataPrint: [],
                printdate: '',//签收日期
                showPrintDate: false, // 是否显示签收日期弹出框
                rowindex: '',
                oneormore: 1,
                Currency: [], //货币代码
                scrollTop:0,
                rowindexAuditer:'',
                selectDataAuditer:[],
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
            personData: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
            'dataDetail.DTLog_Car_PrintNo': function(){
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(0)
                })
            },
            'dataDetail.DTAuditInfo': function(){
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(1)
                    that.$processdata.initFormRight(2)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('logcarview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6579]"),this.$t("getapi[6577]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_No)) {
                    if (that.dataDetail.Master.Status != 2) {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
                    }
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
                }
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.submit = false
                that.btn.unusualsubmit = false
                that.btn.close = true
                // 所有单据必须有客户签收的回单上传后才能关闭
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_No)){
                    if(that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 3){
                        that.btn.submit = true
                    }
                    if(that.dataDetail.Master.UCStatus == 0 || that.dataDetail.Master.UCStatus == 3 ){
                        that.btn.unusualsubmit = true
                    }
                    if(that.dataDetail.Master.Status == 4){
                        that.btn.close = false
                        that.btn.submit = false
                    }
                } else {
                    that.btn.close = false
                    that.btn.submit = false
                    that.btn.unusualsubmit = false
                }
                that.btn.transfer = false
                if(that.selectData.length > 0){
                    let vendercode = that.selectData[0].Vender_Code
                    that.btn.transfer = that.selectData.every(val => {
                        return val.Vender_Code == vendercode
                    });
                }
                that.currentAuditId = 0
                if(that.dataDetail.DTAuditInfo.length > 0) {
                    let arr = that.dataDetail.DTAuditInfo.filter(row => row.Audit_Status == 0 || row.Audit_Status == 2)
                    let compare = function (obj1, obj2) {
                        let val1 = obj1.Sort;
                        let val2 = obj2.Sort;
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    let sortArr = arr.sort(compare);
                    if(sortArr.length > 0){
                        that.currentAuditId = sortArr[0].Exclusively_ID
                    }
                }
                that.btn.onlyone = false
                let onlyonearr = []
                for(let i = 0;i<that.dataDetail.DTAuditInfo.length;i++){
                    if(that.dataDetail.DTAuditInfo[i].Unusual_Flag == false){
                        onlyonearr.push(that.dataDetail.DTAuditInfo[i])
                    }
                }
                if(onlyonearr.length == 1){
                    that.btn.onlyone = true
                } else {
                    that.btn.onlyone = false
                }
            },
            selectInfo(tab, event){
                let that = this
                that.SelectIndexs = tab.name
                if(that.SelectIndexs == 0){
                    that.getView()
                } else if(that.SelectIndexs == 1){
                    that.getAuditPerson()
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndexs)
                });
            },
            tableRowClassNamePrint({row, rowIndex}){
                row.index = rowIndex
            },
            tableRowClassNameun({ row, rowIndex }) {
                row.index = rowIndex;
            },
            tableRowClassName1({row, rowIndex}){
                if(row.Unusual_Flag == 1){
                    return 'hidden'
                }
            },
            tableRowClassName2({row, rowIndex}){
                if(row.Unusual_Flag != 1){
                    return 'hidden'
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('logcarview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'LogCarViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            getAuditPerson(){
                let that = this
                let parm = {
                    AuditPerson: that.user
                }
                that.$http.urlpost('/LogCar/LogCarListByAuditPerson', parm , function (res) {
                    if (res.Success == 1) {
                        that.personData = res.DataContent
                    }
                });
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/LogCar/GetLogCarView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.Exclusively_ID){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.DTLog_Car_PrintNo.length;i++){
                        delete datacopy.DTLog_Car_PrintNo[i]['index']
                    }
                    for(let i = 0;i<datacopy.Log_Car_UnusualCostList.length;i++){
                        delete datacopy.Log_Car_UnusualCostList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.addoredit = 2;
                                that.code = row.Exclusively_ID
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.addoredit = 2;
                        that.code = row.Exclusively_ID
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/LogCar/LogCarInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.getNoTaxedCost()
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            getNoTaxedCost(){
                let that = this
                if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Actual_Cost) && that.$limits.fnIsEmpty(that.dataDetail.Master.NoTaxed_Cost)){
                    that.dataDetail.Master.NoTaxed_Cost = that.$processdata.mathRound2(that.dataDetail.Master.Actual_Cost / 1.09)
                }
            },
            // 新增
            add() {
                let that = this;
                that.$http.urlpost('/LogCar/CheckOrderClose', '', function (res) {
                    if (res.Success == 2) {
                        that.$confirm(that.$t('getapi[8602]'), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let datacopy = that.dataDetail
                                for(let i = 0;i<datacopy.DTLog_Car_PrintNo.length;i++){
                                    delete datacopy.DTLog_Car_PrintNo[i]['index']
                                }
                                for(let i = 0;i<datacopy.Log_Car_UnusualCostList.length;i++){
                                    delete datacopy.Log_Car_UnusualCostList[i]['index']
                                }
                                if(that.oldDataDetail != JSON.stringify(datacopy)){
                                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                                        confirmButtonText: that.$t('getapi[2052]'),
                                        cancelButtonText: that.$t('getapi[2053]'),
                                        type: 'warning'
                                    })
                                        .then(() => {
                                            that.save()
                                        })
                                        .catch(() => {
                                            that.openEdit()
                                            that.confirmAdd()
                                        });
                                } else {
                                    that.openEdit()
                                    that.confirmAdd()
                                }
                            })
                            .catch(() => {
                            });
                    } else {
                        if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                            that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.save()
                                })
                                .catch(() => {
                                    that.openEdit()
                                    that.confirmAdd()
                                });
                        } else {
                            that.openEdit()
                            that.confirmAdd()
                        }
                    }
                });
            },
            confirmAdd(){
                let that = this;
                let datetime = (
                    new Date().getFullYear() +
                    '-' +
                    (new Date().getMonth() + 1) +
                    '-' +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    ':' +
                    new Date().getMinutes() +
                    ':' +
                    new Date().getSeconds()
                ).toString();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Master: {
                        Exclusively_ID: 0,
                        Doc_No: '',
                        Status: 0,
                        UCStatus: 0,
                        Create_Person: '',
                        Create_Person_Dept: '',
                        Create_Time: '',
                        Modify_Person: '',
                        Modify_Time: '',
                        Goods_Name: '',
                        Goods_Des: '',
                        Goods_Type: '',
                        Vender_Code: '',
                        Goods_Carrier: '',
                        Start_Place: '',
                        End_Place: '',
                        Start_Time: '',
                        End_Time: '',
                        Car_Type: '',
                        Item_Name: '',
                        Item_Code: '',
                        Expect_Cost: 0,
                        Remark: '',
                        Driver_Phone: '',
                        Car_Num: '',
                        GetPlace_Time: '',
                        Actual_Cost: 0,
                        Unusual_Cost: 0,
                        Unusual_Remark: '',
                        Receipt_Time: '',
                        Receipt_Url: '',
                        Trans_Content: '',
                        Invoice_No: '',
                        NoTaxed_Cost: '',
                        IsEdit: 1,
                        Audit_Person: '',
                        Volume:'',
                        Weight:'',
                        Single_Mile:'',
                        Back_Track:true,
                        IPO_Code:'',
                        Sale_Code:'',
                        Pur_Code:'',
                        Quantity: '',
                        Item_ShotrCode: '',
                        Unusual_Cost_Currency: '',
                        Notice_Log: '',
                        Notice_Time: '',
                        Goods_Value: null,
                        Goods_Currency: '',
                    },
                    DTAuditInfo: [],
                    DTLog_Car_PrintNo: [],
                    Log_Car_UnusualCostList:[],
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTLog_Car_PrintNo.length;i++){
                    delete datacopy.DTLog_Car_PrintNo[i]['index']
                }
                for(let i = 0;i<datacopy.Log_Car_UnusualCostList.length;i++){
                    delete datacopy.Log_Car_UnusualCostList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 2){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit == 2){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/LogCar/GetLogCarViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                if(that.dataDetail.Master.Goods_Name == ''){
                    that.$message.warning(that.$t('getapi[8662]'))//'物品名称不能为空！'
                    return
                }
                if(that.dataDetail.Master.Item_Code == ''){
                    that.$message.warning(that.$t('getapi[8663]'))//'项目代码不能为空！'
                    return
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.dataDetail.Master.Modify_Person = that.user
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogCar/SaveLogCar', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getView()
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });

            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[8057]')//'审核中'
                } else if(val == 2){
                    return that.$t('getapi[5160]')//'批准'
                } else if(val == 3){
                    return that.$t('getapi[5161]')//'驳回'
                } else if(val == 4){
                    return that.$t('getapi[441]')//'关闭'
                } else if(val == 5){
                    return that.$t('getapi[1902]')//'作废'
                } else {
                    return ''
                }
            },
            expunStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[6468]')//'提交'
                } else if(val == 2){
                    return that.$t('getapi[941]')//'审核'
                } else if(val == 3){
                    return that.$t('getapi[5161]')//'驳回'
                } else {
                    return ''
                }
            },
            expAuditStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1233]')//'待审'
                } else if(val == 1){
                    return that.$t('getapi[3607]')//'审核'
                } else if(val == 2){
                    return that.$t('getapi[5161]')//'驳回'
                } else {
                    return ''
                }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: that.dataDetail.Master.Exclusively_ID
                        }
                        that.$http.urlpost('/LogCar/DelLogCarByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 1提交4关闭
            setStatus(val){
                let that = this;
                if(that.dataDetail.Master.Goods_Name == ''){
                    that.$message.warning(that.$t('getapi[8662]'))//'物品名称不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Type == ''){
                    that.$message.warning(that.$t('getapi[8664]'))//'运输类型不能为空！'
                    return
                }
                if(that.dataDetail.Master.Start_Place == ''){
                    that.$message.warning(that.$t('getapi[8665]'))//'起始地点不能为空！'
                    return
                }
                if(that.dataDetail.Master.End_Place == ''){
                    that.$message.warning(that.$t('getapi[8666]'))//'送货点不能为空！'
                    return
                }
                if(that.dataDetail.Master.Start_Time == ''){
                    that.$message.warning(that.$t('getapi[8641]'))//'提货时间不能为空！'
                    return
                }
                if(that.dataDetail.Master.End_Time == ''){
                    that.$message.warning(that.$t('getapi[8642]'))//'到货时间不能为空！'
                    return
                }
                if(that.dataDetail.Master.Item_Code == ''){
                    that.$message.warning(that.$t('getapi[8663]'))//'项目代码不能为空！'
                    return
                }
                if(that.dataDetail.Master.Car_Type == ''){
                    that.$message.warning(that.$t('getapi[8667]'))//'车型不能为空！'
                    return
                }
                if(that.dataDetail.Master.Vender_Code == ''){
                    that.$message.warning(that.$t('getapi[1252]'))//'供应商代码不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Carrier == ''){
                    that.$message.warning(that.$t('getapi[8668]'))//'承运单位不能为空！'
                    return
                }
                if(that.dataDetail.Master.Expect_Cost == ''){
                    that.$message.warning(that.$t('getapi[8669]'))//'预计费用不能为空！'
                    return
                }
                if(that.dataDetail.Master.Driver_Phone == ''){
                    that.$message.warning(that.$t('getapi[8670]'))//'司机电话不能为空！'
                    return
                }
                if(that.dataDetail.Master.Car_Num == ''){
                    that.$message.warning(that.$t('getapi[8671]'))//'车牌号不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Value == null && that.dataDetail.Master.goodsTypeArray == '国内成品'){
                    that.$message.warning(that.$t('getapi[8645]'))//'货值不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Currency == ''  && that.dataDetail.Master.goodsTypeArray == '国内成品'){
                    that.$message.warning(that.$t('getapi[8646]'))//'货值币种不能为空！'
                    return
                }
                if(val == 4 && that.$limits.fnIsEmpty(that.dataDetail.Master.Actual_Cost)){
                    that.$message.warning(that.$t('getapi[11734]'))//'实际费用不能为空！'
                    return
                }
                that.dataDetail.Master.Status = val
                let parm = that.dataDetail.Master;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogCar/LogCarSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.getDetail(that.code)
                });
            },
            // 异常费用提交
            unusualSetStatus(val){
                let that = this
                that.dataDetail.Master.UCStatus = val
                let parm = that.dataDetail.Master
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogCar/UnusualCostSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.code)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 导出台账
            expStandBook(){
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[11868]')
                };
                that.$http.urlpost('/LogCar/StandBookToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 审核 驳回
            Audit(scope,flag){
                let that =this;
                if(flag == 1){
                    this.$confirm(that.$t('getapi[8606]'), that.$t('getapi[194]'), {//'确认审核通过吗'
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.confirmAudit(scope.row,1)
                        })
                        .catch(() => {
                        });
                } else if(flag==2){
                    that.CloseDialogVisible = true;
                    that.selectrow = scope.row;
                    that.resontxt = '';
                }
            },
            // 删除审核人
            delAuditer(val){
                let that = this
                let parm = {
                    ids: val.row.Exclusively_ID
                }
                that.$http.urlpost('/LogCar/DelLogCarAuidtInfoByID', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.code);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.authority()
                    }
                });
            },
            confirmAudit(row,type){
                let that = this
                row.Audit_Date = that.$limits.getDateTime()
                if(type == 1){
                    row.Audit_Msg = ''
                } else {
                    row.Audit_Msg = that.resontxt
                }
                row.Audit_Status = type
                let parm = row
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogCar/LogCarInfoSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView();
                        that.getDetail(that.code);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                    } else {
                        that.getDetail(that.code);
                    }
                });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                    that.authority()
                    that.getView()
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile() {
                let that = this;
                if (!/\.(pdf|PDF)$/.test(that.file.name)) {
                    that.$message.warning(that.$t('getapi[8672]'));//文件必须为PDF格式
                    return;
                }
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Exclusively_ID', that.dataDetail.Master.Exclusively_ID)
                formData.append('Actual_Cost', that.dataDetail.Master.Actual_Cost)
                that.$http.urlpost('/LogCar/UploadFilesResult', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dataSet = res.DataContent
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 查看文件
            open(url){
                let that = this
                let hrefurl = Common.Url + url;
                window.open(hrefurl);
            },
            transfer(){
                let that = this;
                that.$store.commit('setSharedParams',that.selectData);
                let item = {
                    label: this.$t('getapi[3676]'),
                    name: '3_purinvoiceview',
                    path: '/purinvoiceview',
                    url: '/purinvoiceview',
                    icon: 'video-play'
                };
                this.$router.push({
                    name: '3_purinvoiceview',
                    label: this.$t('getapi[3676]'),
                    path: '/purinvoiceview',
                });
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            // 批量选择(异常费用)
            handleSelectionChangeun(val) {
                let that = this;
                that.selectunData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectunData.push(val[i]);
                }
            },
            selectItemCode() {
                let that = this;
                that.$refs.itemcode.clearInput(true);
            },
            getItemCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Item_ShotrCode = val.item_code.split('-')[0]
                that.dataDetail.Master.Item_Code = val.item_code;
                that.dataDetail.Master.Item_Name = val.item_name;
            },
            selectVenderCode() {
                let that = this;
                that.$refs.vendercode.clearInput(true);
            },
            getVenderCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Vender_Code = val.vender_code;
                that.dataDetail.Master.Goods_Carrier = val.vender_name;
            },
            // 新增打印码
            addPrint(){
                let that = this
                that.oneormore = 1
                that.$refs.saleshipnote.clearInput(true);
            },
            selectprintno(){
                let that = this
                that.oneormore = 2
                that.$refs.saleshipnotesingle.clearInput(true);
            },
            getSaleShipNote(data){
                let that = this
                console.log(data)
                if(that.oneormore == 1){
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.DTLog_Car_PrintNo = [...that.dataDetail.DTLog_Car_PrintNo,{
                            Exclusively_ID: 0,
                            Relation_IID: 0,
                            print_no: data[i].print_no,
                            Create_Person: '',
                            Create_Time: '',
                            Sign_Time: ''
                        }]
                    }
                } else {
                    that.dataDetail.DTLog_Car_PrintNo[that.rowindex].print_no = data.print_no
                }

            },
            // 删除打印码
            delPrint(){
                let that = this
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let id = ''
                        for (let i = that.selectDataPrint.length - 1; i >= 0; i--) {
                            that.dataDetail.DTLog_Car_PrintNo.splice(that.selectDataPrint[i].index, 1);
                            if (that.selectDataPrint[i].Exclusively_ID != 0) {
                                id = id + that.selectDataPrint[i].Exclusively_ID + ','
                            }
                        }
                        if (id.length > 0) {
                            id = id.substr(0, id.length - 1);
                            let parm = {
                                ids: id
                            }
                            that.$http.urlpost('/LogCar/DelLog_Car_PrintNoByID', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.code);
                                }
                            });
                        }
                    })
                    .catch(() => {
                    });
            },
            // 批量填写打印日期
            batchPrintDate(){
                let that = this
                for(let i = 0;i<that.selectDataPrint.length;i++){
                    if(that.selectDataPrint[i].Exclusively_ID == 0){
                        that.$message.warning(that.$t('getapi[4868]'))//'请先保存单据！'
                        return
                    }
                }
                that.printdate = ''
                that.showPrintDate = true
            },
            confirmBatchPrintDate(){
                let that = this
                /* for(let i = 0;i<that.selectDataPrint.length;i++){
                     for(let j = 0;j<that.dataDetail.DTLog_Car_PrintNo.length;j++){
                         if(that.selectDataPrint[i].index == that.dataDetail.DTLog_Car_PrintNo[j].index){
                             that.dataDetail.DTLog_Car_PrintNo[j].Sign_Time = that.printdate
                         }
                     }
                 }*/
                let parm = {
                    Sign_Time: that.printdate,
                    DTLog_Car_PrintNo: that.selectDataPrint
                }
                that.$http.urlpost('/LogCar/PrintNoSetSignTime', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                        that.showPrintDate = false
                    }
                });

            },
            handleSelectionChangePrint(val){
                let that = this
                that.selectDataPrint = val
            },
            handleSelectionChangeAuditer(val){
                let that = this
                that.selectDataAuditer = val
            },
            // 撤回
            recall(){
                let that = this
                let parm = that.dataDetail.Master
                that.$http.urlpost('/LogCar/OrderReCall', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            // 邮件通知
            email(){
                let that = this
                let parm = that.dataDetail.Master
                parm.LangType =  that.$processdata.getLang()
                that.$http.urlpost('/LogCar/LogCarNoticeLog', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            copy(){
                let that = this
                this.$confirm(that.$t('getapi[13076]'), that.$t('getapi[194]'), {//'确定复制单据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.addoredit = 1;
                        that.code = ''
                        that.dataDetail.Master.Doc_No = ''
                        that.dataDetail.Master.Exclusively_ID=0
                        that.dataDetail.Master.Status= 0
                        that.dataDetail.Master.UCStatus = 0
                        that.dataDetail.Master.IsEdit = 1,
                        that.dataDetail.Master.Audit_Person = '',
                        that.dataDetail.Master.Modify_Person='',
                        that.dataDetail.Master.Modify_Time='',
                        that.dataDetail.Master.Submit_Person='',
                        that.dataDetail.Master.Submit_Time='',
                        that.dataDetail.Master.Create_Person='',
                        that.dataDetail.Master.Create_Person_Dept='',
                        that.dataDetail.Master.Create_Time='',
                        that.dataDetail.DTAuditInfo = [],
                        that.dataDetail.DTLog_Car_PrintNo= []
                        that.dataDetail.Log_Car_UnusualCostList= []
                        that.dataDetail = {...that.dataDetail};
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 新增异常费用
            addunline(){
                let that = this
                that.dataDetail.Log_Car_UnusualCostList = [...that.dataDetail.Log_Car_UnusualCostList,{
                    Exclusively_ID: 0,
                    Relation_IID: that.dataDetail.Master.Exclusively_ID,
                    Create_Person: that.user,
                    Create_Time: '',
                    Status: 0,
                    Audit_Time: '',
                    Unusual_Remark: '',
                    Unusual_Cost: '',
                    Unusual_Cost_Currency: '',
                    Unusual_Cost_Url: '',
                    Unusual_Cost_Time: ''
                }]
            },
            // 删除异常费用
            delunline(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectunData.length - 1; i >= 0; i--) {
                            that.dataDetail.Log_Car_UnusualCostList.splice(that.selectunData[i].index, 1);
                            if(that.selectunData[i].Exclusively_ID!=0){
                                ids = ids + that.selectunData[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids,
                                LangType:that.$processdata.getLang()
                            }
                            that.$http.urlpost('/LogCar/DelLogCarUnusualCostID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 异常费用附件上传
            handleRemove5(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview5(file) {
                console.log("handlePreview"+file);
            },
            handleChange5(file, fileList) {
                let that = this;
                that.file5 = file.raw
            },
            handleSuccess5(res, file, fileList) {
                let that = this;
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList5=[];
            },
            handleError5(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            bindId(id){
                let that = this
                that.Line_ID = id
            },
            uploadFile5(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file5);
                formData.append('Line_ID', that.Line_ID)
                that.$http.urlpost('/LogShip/UploadFilesUnusual_Cost', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            //保存异常费用
            saveun(){
                let that = this
                let parm = that.dataDetail.Log_Car_UnusualCostList
                that.$http.urlpost('/LogCar/SaveLogCarUnusualCost', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            // 新增审核人
            addauditer(){
                let that = this
                that.dataDetail.DTAuditInfo = [...that.dataDetail.DTAuditInfo,{
                    Exclusively_ID: 0,
                    Relation_IID: that.dataDetail.Master.Exclusively_ID,
                    Sort: '',
                    Audit_Type: '',
                    Audit_Person: '',
                    userID: '',
                    Audit_Status: 0,
                    Audit_Date: '',
                    Audit_Msg: '',
                    superior_flag: 0,
                    Unusual_Flag: false,
                    LangType: 0
                }]
            },
            // 删除审核人
            delauditer(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectDataAuditer.length - 1; i >= 0; i--) {
                            that.dataDetail.DTAuditInfo.splice(that.selectDataAuditer[i].index, 1);
                            if(that.selectDataAuditer[i].Exclusively_ID!=0){
                                ids = ids + that.selectDataAuditer[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids,
                                LangType:that.$processdata.getLang()
                            }
                            that.$http.urlpost('/LogCar/DelLogCarAuidtInfoByID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //保存审核人
            saveauditer(){
                let that = this
                let parm = that.dataDetail.DTAuditInfo
                that.$http.urlpost('/LogCar/SaveAuditinfo', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            selectAuditer(row){
                let that = this
                that.rowindexAuditer = row.$index
                that.$refs.auditer.clearInput(true);
            },
            getAuditer(data){
                let that = this
                console.log(data)
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].Audit_Person = data.name
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].userID = data.code
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].Audit_Type = 1
            },
            checkDataChange(){
                let that = this
                //能打开此页面即拥有保存权限
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTLog_Car_PrintNo.length;i++){
                    delete datacopy.DTLog_Car_PrintNo[i]['index']
                }
                for(let i = 0;i<datacopy.Log_Car_UnusualCostList.length;i++){
                    delete datacopy.Log_Car_UnusualCostList[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-upload-list{
        display:none
    }
    /deep/ .gray {
        background: #cac6c6;
    }
    /deep/ .hidden {
        display: none;
    }
</style>
